export default {
 methods: {
  exportToExcel() {
   this.gridOptions.api.exportDataAsExcel({
    processCellCallback: ({ value }) => {
     if (typeof value === "object") return value?.name;
     const num = parseFloat(value);
     return !isNaN(num) && isFinite(num) ? +num.toFixed(2) : value;
    },
   });
  },
 },
 data() {
  return {};
 },
};
